import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackPageView } from '@/analytics';

function useTrackPageView() {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location.pathname]);
}

export default useTrackPageView;
